import i1 from "./images/i1.jpg";
import i2 from "./images/i2.jpg";
import i3 from "./images/i3.jpg";
import './Slider.css';

function Slider (){

    return(
        <div id="carouselExample" className="carousel slide">
            <div className="carousel-inner">
                <div className="carousel-item active">
                <img src={i2} className="d-block w-100" alt="..."/>
                </div>
                <div className="carousel-item">
                <img src={i1} className="d-block w-100 active" alt="..."/>
                </div>
                <div className="carousel-item">
                <img src={i3} className="d-block w-100" alt="..." />
                </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
}
export default Slider;